  <template>
  <div class="log-list" style="over-flow-x:auto;">
    <h2>打刻ログ</h2>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="logList"
      :items-per-page="50"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="no"
      show-expand
      hide-default-footer
    >
    <!-- カードタイプの表示の仕方 -->
      <template v-slot:[`item.type`]="{ item }">
        {{item.type|convertCardType}}
      </template>
      <!-- カードIDの表示の仕方 -->
      <template v-slot:[`item.cid`]="{ item }">
        <!-- <div v-if="item.type==='B1'" v-html="$options.filters.parseBID(item.bid)" style="font-size:0.9rem;">
        </div> -->
        <div v-if="item.type==='B1'">
          {{item.bid}}
        </div>
        <div v-else>
          {{item.cid}}
        </div>
      </template>
      <!-- 打刻時刻の表示の仕方 -->
      <template v-slot:[`item.time`]="{ item }">
        <div v-html="$options.filters.moment(item.time)"></div>
      </template>
      <!-- サーバ時刻の表示の仕方 -->
      <template v-slot:[`item.serverTime`]="{ item }">
        <div v-html="$options.filters.moment(item.serverTime)"></div>
      </template>
      <!-- 再送の表示の仕方 -->
      <template v-slot:[`item.tx`]="{ item }">
        <font style="color:#F00">
          {{item.tx|checkResend}}
        </font>
      </template>
      <!-- 署名カラムのカラム名の表示の仕方 -->
      <template v-slot:[`header.kid`]="{ header }">
        <span v-html="header.text"></span>
      </template>
      <!-- 署名の表示の仕方 -->
      <template v-slot:[`item.kid`]="{ item }">
        <!-- 現在の仕様ではkidがnullの場合は端末認証はしないし、
        端末認証に失敗すると打刻されないのでkidがnull, 空文字, かどうかで判定する。 -->
        <div v-if="item.kid">
          OK<br>({{item.kid.substr(0,4)}})
        </div>
        <div v-else>
          ---
        </div>
      </template>
      <template v-slot:expanded-item="{headers, item }">
        <td :colspan="headers.length" class="extra_params" align="left">
          <div v-if="item.device==='Biz'" style="word-break: break-all;">
            <h3>Bizの固有パラメーター</h3>
            <!-- <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>TypeBカードID:</v-list-item-title>
                <span :class="$style.extraparams">{{item.bid}}</span>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>OPTAUTH:</v-list-item-title>
                <span :class="$style.extraparams">{{item.optauth}}</span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>OPTVAL:</v-list-item-title>
                <span :class="$style.extraparams">{{item.optval}}</span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>OPTNAME:</v-list-item-title>
                <span :class="$style.extraparams">{{item.optname}}</span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>VAL1:</v-list-item-title>
                <span :class="$style.extraparams">{{item.val1}}</span>

              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>VAL2:</v-list-item-title>
                <span :class="$style.extraparams">{{item.val2}}</span>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div v-if="item.device==='Pro / Pro2'||item.device==='Pro3'" style="word-break: break-all;">
            <h3>{{item.device}}の固有パラメーター</h3>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>EXT: </v-list-item-title>
                <span :class="$style.extraparams">{{item.ext}}</span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>CNAME:</v-list-item-title>
                <span :class="$style.extraparams">{{item.cname}}</span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>IDX: </v-list-item-title>
                <span :class="$style.extraparams">{{item.idx}}</span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>DATA: </v-list-item-title>
                <span :class="$style.extraparams">{{item.data}}</span>
              </v-list-item-content>
            </v-list-item>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
  </template>

<script>
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'LogView',
  data () {
    return {
      expanded: [],
      singleExpand: true,
      headers: [
        {text: 'No.', sortable: true, value: 'no', divider: 'true', align: 'center'},
        {text: 'サーバ時刻', sortable: false, value: 'serverTime', divider: 'true', align: 'center'},
        {text: '打刻時刻', sortable: false, value: 'time', divider: 'true', align: 'center'},
        {text: '端末', sortable: false, value: 'device', divider: 'true', align: 'center'},
        {text: '端末ID', sortable: false, value: 'tid', divider: 'true', align: 'center'},
        {text: 'カードID', sortable: false, value: 'cid', divider: 'true', align: 'center'},
        {text: 'タイプ', sortable: false, value: 'type', divider: 'true', align: 'center'},
        {text: 'STATUS', sortable: false, value: 'sts', divider: 'true', align: 'center'},
        {text: '再送', sortable: false, value: 'tx', divider: 'true', align: 'center'},
        {text: '署名<br/>（kid）', sortable: false, value: 'kid', divider: 'true', align: 'center'}
      ],
      logList: []
    }
  },
  created () {
    this.loadLogList()
  },
  mounted () {
    this.reloadLogList()
  },
  filters: {
    moment: function (date) {
      return date != null ? moment(date).format('yyyy/MM/DD<br/>HH:mm:ss') : ''
    },
    checkResend: function (data) {
      return data === 1 ? '再送' : '\xa0'
    },
    checkBlank: function (data) {
      return (data === null || data === '') ? '\xa0' : data
    },
    convertCardType: function (data) {
      const conds = ['11', '21', '12', '32', '42', '52', '92', '1A', '3A', '4A']
      if (data === '00') {
        return 'FeliCa'
      } else if (data === 'A0') {
        return 'TypeA'
      } else if (data === 'A1') {
        return 'MIFARE 1K'
      } else if (data === 'A2') {
        return 'MIFARE 4K'
      } else if (data === 'A3') {
        return 'MIFARE UL'
      } else if (data === 'B1') {
        return 'eLWISE'
      } else if (conds.includes(data)) {
        return 'mobile FeliCa'
      } else {
        return ''
      }
    },
    parseBID: function (bid) {
      let bidParsed = bid.split('-')
      let limitDate = bidParsed[1].substr(0, 4) + '/' + bidParsed[1].substr(4, 2) + '/' + bidParsed[1].substr(6, 2) +
                  ' ' + bidParsed[1].substr(8, 2) + ':' + bidParsed[1].substr(10, 2) + ':' + bidParsed[1].substr(12, 2)

      return `${bidParsed[0]}<br/>（有効期限：${limitDate}）`
    }
  },
  methods: {
    loadLogList: function () {
      axios.get('/logList').then((res) => {
        this.logList = res.data
      })
    },
    reloadLogList: function () {
      this.$setInterval(() => {
        this.loadLogList()
      }, 5000)
    }
  }
}
</script>

<!-- <style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 18px;
}

.v-data-table>.v-data-table__wrapper>table>thead>tr>th>span {
    font-size: 18px;
}

.v-list-item__title {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size: 1.3rem;
}
span {
  font-size: 18px;
}
</style> -->

<style>
h2 {
  margin-bottom: 30px;
}
h3 {
  margin-top: 10px;
}
.v-data-table>.v-data-table__wrapper>table>thead>tr>th>span {
  font-size: 1.2rem;
  color:#fff;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 1.1rem;
}

.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  padding: 8px 15px;
  background: #258;
  background:-moz-linear-gradient(rgba(34,85,136,0.7), rgba(34,85,136,0.9) 50%);
  background:-webkit-gradient(linear, 100% 0%, 100% 50%, from(rgba(34,85,136,0.7)), to(rgba(34,85,136,0.9)));
  border-top:1px solid #258;
  border-bottom:1px solid #258;
  line-height: 120%;
  text-align: center;
  text-shadow:0 -1px 0 rgba(34,85,136,0.9);
  box-shadow: 0px 1px 1px rgba(255,255,255,0.3) inset;
}

.v-list-item__title {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-weight:bold;
  color: rgba(0, 0, 0, .6);
  font-size: 1.2rem;
}
</style>

<style module>
.extraparams {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/LogView.vue